import { FC } from "react";
import Link from "next/link";
import { StyledBreadCrumbs } from "./BreadCrumbs.styled";
import { HierarchyProps } from "../../types/Article.types";

interface Props {
  hierarchy: HierarchyProps;
}

const BreadCrumbs: FC<Props> = ({ hierarchy }) => {
  if (!hierarchy) {
    return null;
  }
  return (
    <StyledBreadCrumbs>
      {hierarchy.map(({path, name}, index) => (
        <Link key={index} href={path}>
          {name}
        </Link>
      ))}
    </StyledBreadCrumbs>
  );
};

export default BreadCrumbs;
